<template>
  <ViceButton
    @click="handleMonitorConnection"
    circle
    white
    :showNotification="isActive"
    style="padding: 0 !important"
    :btnDescription="btnDescription"
    :class="{ 'sm:bg-vice-teal-600 hover:bg-vice-teal-700': isActive }"
    class="w-12 h-12 border-none bg-vice-light-grey"
    :disabled="isConnected || loading"
  >
    <ViceLoader colorClass="text-vice-teal-700" class="left-2" v-if="loading" />

    <template v-else>
      <ViceMonitor class="w-10 h-10" :pathFill="!isActive ? '#0F766E' : '#fff'" />
    </template>
  </ViceButton>
</template>

<script>
import { computed, ref } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';
import useLocalStreamingDevicesStore from '@/Stores/useLocalStreamingDevicesStore';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import ViceMonitor from '../Icons/ViceMonitor.vue';
import ViceLoader from '../Loaders/ViceLoader.vue';
import { MONITOR_LABELS, EXTERNAL_CONNECTED_VIDEO_DEVICES } from '@/Utils/vice-constants';

export default {
  name: 'AddMonitorButton',
  components: {
    ViceButton,
    ViceMonitor,
    ViceLoader,
  },
  setup() {
    const loading = ref(false);

    const sessionStore = useSessionStore();
    const multiCameraDevicesStore = useLocalStreamingDevicesStore();

    const isActive = computed(() =>
      multiCameraDevicesStore.allExternalConnectedVideoDevices.find(
        (deviceName) => deviceName === EXTERNAL_CONNECTED_VIDEO_DEVICES.MONITOR,
      ),
    );
    const isConnected = computed(
      () =>
        !multiCameraDevicesStore.groupedDeviceAsAudioAndVideo.VIDEO.Camera.find((device) =>
          MONITOR_LABELS.some((singleLabel) => device.label.includes(singleLabel)),
        ),
    );

    const btnDescription = computed(() =>
      isActive.value ? `Disconnect Diagnostic Imaging` : `Connect Diagnostic Imaging`,
    );

    const handleMonitorConnection = async () => {
      try {
        loading.value = true;
        sessionStore.toggleControlPanel(true);

        if (isActive.value) {
          await multiCameraDevicesStore.removeExternalVideoDevice(
            EXTERNAL_CONNECTED_VIDEO_DEVICES.MONITOR,
          );
        } else {
          await multiCameraDevicesStore.addExternalVideoDevice(
            sessionStore.sessionId,
            EXTERNAL_CONNECTED_VIDEO_DEVICES.MONITOR,
            MONITOR_LABELS,
          );
        }
      } catch (error) {
        console.error({ error });
      } finally {
        loading.value = false;
      }
    };

    return {
      isConnected,
      isActive,
      loading,
      btnDescription,
      handleMonitorConnection,
    };
  },
};
</script>
